/*
  ブログ記事の「リンクをコピー」
  sections/custom-article.liquid

  編集はGit経由で行ってください（管理画面から直接編集しないでください）

  ボタンはHTML側で hidden にしてある。ここで出すまで見えない。
  クリップボードに書ける環境かどうかはJSでしか分からないので、
  分かった時点で出す。押せるのに何も起きないボタンを残さないため。

  クリップボードは安全な接続（httpsかlocalhost）でしか使えない。
  プレビューは https なので通るが、判定は環境まかせにせず毎回見る
*/
(function () {
  var DONE_MS = 2000;

  function canCopy() {
    return !!(navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext);
  }

  /*
    書き込みを断られている環境かどうかを聞く。
    断られていることが分かったときだけ隠す。

    Firefox と Safari はこの名前の権限を知らず問い合わせ自体が失敗するが、
    その2つは操作をきっかけにした writeText なら通る。
    だから「分からない」ときは出す側に倒す
  */
  function watchPermission(onChange) {
    if (!navigator.permissions || !navigator.permissions.query) {
      onChange(true);
      return;
    }

    navigator.permissions.query({ name: 'clipboard-write' }).then(
      function (status) {
        onChange(status.state !== 'denied');
        status.onchange = function () {
          onChange(status.state !== 'denied');
        };
      },
      function () {
        onChange(true);
      }
    );
  }

  function setup(root) {
    var button = root.querySelector('[data-c-share-copy]');
    if (!button || !canCopy()) return;

    var idle = button.textContent.trim();
    var done = button.getAttribute('data-c-share-done') || idle;
    var url = button.getAttribute('data-c-share-url') || window.location.href;
    var timer = null;

    watchPermission(function (allowed) {
      button.hidden = !allowed;
    });

    button.addEventListener('click', function () {
      navigator.clipboard.writeText(url).then(
        function () {
          button.textContent = done;
          /*
            読み上げにも伝える。文字が入れ替わるだけだと
            画面を見ていない人にはコピーできたことが分からない
          */
          button.setAttribute('aria-live', 'polite');

          window.clearTimeout(timer);
          timer = window.setTimeout(function () {
            button.textContent = idle;
          }, DONE_MS);
        },
        function () {
          /* 権限を断られたときは何も起きない。押す前の文字のまま残す */
        }
      );
    });
  }

  function init() {
    document.querySelectorAll('[data-c-share]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* テーマエディタでセクションを置き直したときに付け直す */
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-c-share]').forEach(setup);
  });
})();
